<!--  -->
<template>
  <div class="dawbole">
    <div class="seraw">
      <el-input
        v-model="pageIfon.keyword"
        placeholder="请输入id/openId/小程序appid"
        style="width:300px"
      />
      <el-button type="success" icon="el-icon-search" style="margin-left:10px" @click.stop="search">搜索</el-button>
      <el-button type="info" icon="el-icon-refresh-right" style="margin-left:10px" @click.stop="dawe">重置</el-button>
    </div>
    <el-table
      :data="tableData"
      border
      style="width: 100%"
    >
      <el-table-column
        prop="id"
        label="用户ID"
        width="80"
        align="center"
      />
      <el-table-column
        prop="open_id"
        label="OPPNID"
        width="280"
        align="center"
      />
      <el-table-column
        prop="name"
        label="兑换记录"
        width="180"
        align="center"
      >
        <template slot-scope="scope">
          <el-link type="primary" @click="exchange(scope.row.id)">兑换记录</el-link>
        </template>
      </el-table-column>
      <el-table-column
        prop="address"
        label="抽奖记录"
        width="180"
        align="center"
      >
        <template slot-scope="scope">
          <el-link type="primary" @click="luckdraw(scope.row.id)">抽奖记录</el-link>
        </template>
      </el-table-column>
      <el-table-column
        prop="address"
        label="签到记录"
        width="180"
        align="center"
      >
        <template slot-scope="scope">
          <el-link type="primary" @click="signin(scope.row.id)">签到记录</el-link>
        </template>
      </el-table-column>
      <el-table-column
        prop="address"
        label="赠送/扣减记录"
        width="150"
        align="center"
      >
        <template slot-scope="scope">
          <el-link type="primary" @click="giftdeductionall(scope.row.id)">赠送/扣减记录</el-link>
        </template>
      </el-table-column>
      <el-table-column
        prop="book_currency"
        label="公众号书币余额"
        width="180"
        align="center"
      />
      <el-table-column
        prop="book_currency_mp"
        label="企微书币余额"
        width="180"
        align="center"
      />

      <el-table-column
        prop="exchange_book_currency"
        label="提现书币(总计)"
        width="180"
        align="center"
      />
      <el-table-column
        prop="raffle_number"
        label="每日次数"
        width="180"
        align="center"
      />
      <el-table-column
        prop="account_name"
        label="所属小程序"
        width="180"
        align="center"
      />
      <el-table-column
        prop="plat_name"
        label="平台"
        width="180"
        align="center"
      />
      <el-table-column
        prop="auth_app_id_name"
        label="公众号"
        width="180"
        align="center"
      />
      <el-table-column
        prop="nickname"
        label="微信昵称"
        width="180"
        align="center"
      />
      <el-table-column
        prop="nickname"
        label="微信头像"
        width="180"
        align="center"
      >
        <template slot-scope="scope">
          <img v-if="scope.row.head_portrait" :src="scope.row.head_portrait" style="width:100px;height:100px">
        </template>
      </el-table-column>
      <el-table-column
        prop="auth_open_id"
        label="公众号openID"
        width="180"
        align="center"
      />

      <el-table-column
        prop="address"
        label="操作"
        width="300"
        align="center"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="teamclick(scope.row.app_id,scope.row.open_id)">团队信息</el-button>
          <el-button type="warning" size="mini" @click="sendbookmoneyallr(scope.row,3)">赠送书币</el-button>
          <el-button type="danger" size="mini" @click="sendbookmoneyallr(scope.row,4)">扣减书币</el-button>
          <!-- @click="sendbookmoney(scope.row)" -->
        </template>
      </el-table-column>
    </el-table>
    <pagination-right
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
    <el-dialog
      :title="type === 3 ? '赠送书币' :'扣减书币'"
      :visible.sync="dialogVisible"
      width="20%"
    >
      <el-input v-model="number" type="number" :placeholder="type === 3 ? '请输入赠送数量' :'请输入扣减数量'" @blur="changenumber" />
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="sendbookmoneyall">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="团队信息"
      :visible.sync="teamdialogVisible"
      width="30%"
    >
      <div>
        <h2>队长</h2>
        <div class="user_boxr">
          <div class="user_item">
            <img v-if="userIfo.head_portrait == ''" class="img_box" src="https://thirdwx.qlogo.cn/mmopen/vi_32/POgEwh4mIHO4nibH0KlMECNjjGxQUq24ZEaGT4poC6icRiccVGKSyXwibcPq4BWmiaIGuG1icwxaQX6grC9VemZoJ8rg/132" alt="">
            <img v-else class="user_item" :src="userIfo.head_portrait" alt="">
          </div>
          <div v-if="userIfo.nickname != ''" class="user_item">昵称：{{ userIfo.nickname }}</div>
          <div v-else class="user_item">昵称：暂未授权</div>
          <div>
            书币：{{ userIfo.book_currency }}
          </div>
        </div>

      </div>
      <div>
        <h2>队员列表</h2>
        <div v-for="item,index in teammates" :key="index" class="user_boxr">
          <div class="user_item" style="margin-bottom:10px">
            <img v-if="item.head_portrait == ''" class="img_box" src="https://thirdwx.qlogo.cn/mmopen/vi_32/POgEwh4mIHO4nibH0KlMECNjjGxQUq24ZEaGT4poC6icRiccVGKSyXwibcPq4BWmiaIGuG1icwxaQX6grC9VemZoJ8rg/132" alt="">
            <img v-else class="img_box" :src="item.head_portrait" alt="">
          </div>
          <div v-if="item.nickname != ''" class="user_item">昵称：{{ item.nickname }}</div>
          <div v-else class="user_item">昵称：暂未授权</div>
          <div>
            书币：{{ item.book_currency }}
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { turnineuserlist, exchangeninecurrency, getTeammateslist } from '@/api/sourceMaterial.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  components: {
    PaginationRight
  },
  data() {
    return {
      tableData: [],
      pageIfon: {
        page: 1,
        pageSize: 10,
        keyword: null
      },
      total: null,
      number: '',
      dialogVisible: false,
      id: '',
      type: null,
      teamdialogVisible: false,
      teammates: [],
      userIfo: {}
    }
  },
  created() {
    this.turnlist()
  },
  mounted() {

  },
  methods: {
    async teamclick(app_id, open_id) {
      this.teamdialogVisible = true
      const data = await getTeammateslist({
        app_id: app_id,
        open_id: open_id
      })
      this.teammates = data.data.teammates
      this.userIfo = data.data.userIfo
      console.log('data', data)
    },
    search() {
      this.pageIfon.page = 1
      this.turnlist()
    },
    // 小程序转盘用户列表
    async turnlist() {
      const data = await turnineuserlist(this.pageIfon)
      this.tableData = data.data.list
      this.total = data.data.total
      console.log('data', data)
    },
    dawe() {
      this.pageIfon.page = 1
      this.pageIfon.pageSize = 10
      this.pageIfon.keyword = null
      this.turnlist()
    },
    // 分页
    fetchPageSize(e) {
      this.pageIfon.pageSize = e
      this.turnlist()
    },
    fetchCurrentPage(e) {
      this.pageIfon.page = e
      this.turnlist()
    },
    exchange(id) {
      this.$router.push({
        path: '/exchange/index',
        query: {
          id: id,
          type: 2
        }
      })
    },
    luckdraw(id) {
      this.$router.push({
        path: '/luckdrawlist/index',
        query: {
          id: id,
          type: 2
        }
      })
    },
    signin(id) {
      this.$router.push({
        path: '/signinlist/index',
        query: {
          id: id,
          type: 2
        }
      })
    },
    giftdeductionall(id) {
      this.$router.push({
        path: '/giftdeduction/index',
        query: {
          id: id,
          type: 2
        }
      })
    },
    sendbookmoney(item) {
      this.$confirm('确定赠送书币吗？, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        exchangeninecurrency({
          id: item.id,
          number: item.bookCurrency
        }).then((res) => {
          console.log('res', res)
          this.$message({
            type: 'success',
            message: '赠送成功!'
          })
          this.turnlist()
        })
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消删除'
        // })
      })
    },
    sendbookmoneyallr(item, type) {
      this.dialogVisible = true
      console.log(item.id)
      this.id = item.id
      this.type = type
    },
    changenumber(val) {
      console.log('val', val)
      if (this.number < 0) {
        this.number = 0
      }
    },
    sendbookmoneyall(item) {
      if (this.number === '') {
        this.$message({
          type: 'error',
          message: '请输入赠送数量'
        })
        return
      }
      exchangeninecurrency({
        id: this.id,
        number: this.number,
        type: this.type
      }).then((res) => {
        console.log('res', res)
        this.$message({
          type: 'success',
          message: `${this.type === 3 ? '赠送成功!' : '扣币成功!'}`
        })
        this.dialogVisible = false
        this.number = ''
        this.turnlist()
      })
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.dawbole{
  padding: 20px;
}
.seraw{
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.img_box{
  width: 80px;
  height: 80px;
  border-radius: 50%;
}
.user_boxr{
  display: flex;
  align-items: center;
}
.user_item{
  margin-right: 30px;
}
</style>
